
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'BannerCardValues',
  data() {
    return {
      isExpanded: true,
      skeletonLoader: true,
      contentCategorie: false,
    }
  },
  computed: {
    ...mapGetters('product-open', ['allCategorias', 'categoriaRelactedOrg']),
    categorys() {
      if (this.categoriaRelactedOrg.length === 0) {
        return this.allCategorias
      } else {
        return this.categoriaRelactedOrg
      }
    },
  },

  async mounted() {
    await this.isAllProdutos()
    this.isExpanded = this.categorys.length > 3
  },

  methods: {
    ...mapActions('product-open', [
      'fetchCategoriaOpen',
      'verifyCookieCategoria',
    ]),
    async isAllProdutos() {
      try {
        if (this.allCategorias.length === 0) {
          await this.fetchCategoriaOpen()
        }
        this.verifyCookieCategoria()
      } catch (error) {
        this.$toast.error('Error: ' + error)
      } finally {
        this.skeletonLoader = false
        this.contentCategorie = true
      }
    },
    toggleExpanded() {
      this.isExpanded = !this.isExpanded
      if (this.isExpanded) {
        window.scrollTo({
          top: 300,
          behavior: 'smooth',
        })
      }
    },
  },
}
